<template>
<v-lazy :options="{'threshold':1}" v-model="loading">
  <v-row class="bg-white mb-8 d-none d-lg-flex pb-6" v-if="tab != null && (offers || (!offers && products.length > 0))">
    <v-col cols="10" class="d-flex align-center justify-start">
      <v-tabs v-if="offers && !loadingTabs">
        <v-tab class="font-weight-bold text-medium text-capitalize" :class="t.id == tab.id && t.type == tab.type ? '': 'text-color-0'" :color="t.id == tab.id && t.type == tab.type ? 'var(--color-one)': 'var(--color-default)'" v-for="t in getTabsClusterOffers" :key="t.id" @click="changeTabs(t)">
          {{ capitalize(t.name) }}
        </v-tab>
      </v-tabs>
      <v-tabs v-else>
        <v-tab class="text-color-1 text-medium font-weight-bold">
          {{ capitalize(tab.name) }}
        </v-tab>
      </v-tabs>
    </v-col>
    <v-col cols="2" class="d-flex align-center justify-end">
      <v-btn flat variant="plain" append-icon="mdi-chevron-double-right" color="var(--color-one)" @click="$router.push('/'+tabName(tab.type)+'/'+tab.id)">
        <b class="text-medium">Ver mais</b>
      </v-btn>
    </v-col>
    <v-col class="v-col-1 d-none d-lg-flex align-center justify-center pa-0">
      <v-btn @click="prev" icon="mdi-chevron-left" variant="tonal" size="large" flat :color="'var(--color-default)'" class="text-huge"></v-btn>
    </v-col>
    <v-col class="v-col-12 v-col-lg-10 d-flex align-center justify-center pa-0">
      <Carousel ref="carousel" :settings="settings" :breakpoints="breakpoints" v-if="products != null" class="carousel-product">
        <Slide v-for="(slide, index) in products" :key="index" :style="offers && index == 0 ? 'width:0px;': (offers && index == 1 ? 'width:'+($refs.carousel.data.slideWidth._value * 2)+'px;' : '')">
          <div v-if="offers && index == 0" style="width: 0px; height: 495px;">
          </div>
          <div v-else-if="offers && index == 1" style="width: 100%; height: 495px;" class="d-flex align-center justify-center cursor-pointer" @click="$router.push('/details/'+slide.barcode)">
            <ImageProduct :image="slide.image"></ImageProduct>
          </div>
          <Product v-else :product="slide" :notImage="true"></Product>
        </Slide>
      </Carousel>
    </v-col>
    <v-col class="v-col-1 d-none d-lg-flex align-center justify-center pa-0">
      <v-btn @click="next" icon="mdi-chevron-right" variant="tonal" size="large" flat :color="'var(--color-default)'" class="text-huge"></v-btn>
    </v-col>
  </v-row>
</v-lazy>
</template>

<script>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide } from 'vue3-carousel';
import Product from './Product.vue';
import ImageProduct from '@/components/ImageProduct.vue';
import { mapGetters, mapActions } from 'vuex';
import { capitalize } from '@/store/services/utils.js';

export default {
  name: 'CarouselProduct',
  components: {
    Carousel,
    Slide,
    Product,
    ImageProduct
  },
  props: {
    offers: {
      type: Boolean,
      default: false
    },
    tabProp: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      loading: false,
      tab: null,
      loadingTabs: false,
      products: [],
      settings: {
        itemsToShow: 1.2,
        snapAlign: 'start',
      },
      breakpoints: {
        700: {
            itemsToShow: 2,
            snapAlign: 'start',
        },
        1280: {
            itemsToShow: 3,
            snapAlign: 'start',
        },
        1500: {
            itemsToShow: 4,
            snapAlign: 'start',
        },
        1800: {
            itemsToShow: 5,
            snapAlign: 'start',
        },
      },
    }
  },
  watch: {
    'getTabsClusterOffers': function (tabs) {
      if(this.offers == true){
        this.loadingTabs = true;
        if(tabs[0] != undefined){
          this.changeTabs(tabs[0]);
        }
      }
    },
    loading: function(){
      this.getProducts();
    },
    tabProp: function(tab){
      if(tab != undefined){
        this.changeTabs(tab);
      }
    }
  },
  computed: {
    ...mapGetters('main', {
      getTabsClusterOffers: 'getTabsClusterOffers',
      getConfig: 'getConfig'
    }),
    ...mapGetters('products', {
      getProdutosFeed: 'getProdutosFeed'
    }),
  },
  methods: {
    ...mapActions('products', {
      getProdutosCarousel: 'getProdutosCarousel',
      getImageCarousel: 'getImageCarousel'
    }),
    capitalize,
    tabName(type){
      var name = null;
      switch(type){
        case 0: name = "cluster"; break;
        case 1: name = "offers"; break;
        case 2: name = "campaign"; break;
        case 3: name = "feed"; break;
      }
      return name;
    },
    next() {
      this.$refs.carousel.slideTo(this.$refs.carousel.data.currentSlide._value + this.$refs.carousel.data.config.itemsToShow);
    },
    prev() {
      this.$refs.carousel.slideTo(this.$refs.carousel.data.currentSlide._value - this.$refs.carousel.data.config.itemsToShow);
    },
    changeTabs(tab){
      this.tab = tab;
      this.getProducts();
    },
    getTypeName(type){
      var name = "";
      switch(type){
        case 0: name = "cluster"; break;
        case 1: name = "offers"; break;
        case 2: name = "campaign"; break;
        case 3: name = "feed"; break;
      }
      return name;
    },
    async getProducts(){
      this.products = [];
      let order = 0;
      if(this.getTypeName(this.tab.type) != "feed"){
        order = 4;
      }
      this.getProdutosCarousel({ "type": this.getTypeName(this.tab.type), "parametros": "0/"+order+"/"+ this.tab.id }).then(function(response){
        if(response != false){
          if(this.getTypeName(this.tab.type) != "feed"){
            this.products.push(response[0]);
            this.products.push(response[0]);
          }
          this.products = this.products.concat(response);
          this.loadingTabs = false;
          this.products.forEach((element, index) => {
            this.getImageCarousel({ sku: element.sku, imghash: index > 2 || this.getTypeName(this.tab.type) != "offers" ? "t-"+element.imghash: element.imghash }).then(function(image){
              element.image = image;
            }.bind(this));
          });
        }
      }.bind(this));
    }
  },
  mounted(){
    if(this.offers){
      this.tab = this.getTabsClusterOffers[0];
    } else {
      this.tab = this.tabProp;
    }
  }
}
</script>